import { render, staticRenderFns } from "./DueCustomerReport.vue?vue&type=template&id=54416bec"
import script from "./DueCustomerReport.vue?vue&type=script&lang=js"
export * from "./DueCustomerReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports